import React  from 'react'

import CustomView from "../../../../../../../core/model2/custom-view/custom-view"

type Props = {
    view: CustomView
}

export default function TypeField(props: Props) {
    return (
        <div className="row">
            <div className="label">Type</div>
            <div className="element simple-value">{props.view._config.name}</div>
        </div>
    )
}